import { AdacHeadline, AdacText } from '@adac-de/component-library';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Partners } from '../../types';
import styles from './offer-form.module.scss';
import { SelectedPartnerBox } from './selected-partner-box';
import { PartnerSelectionFormFields } from './form-steps/partner-selection';
import { PersonalDataFormFields, PersonalDataSection } from './form-steps/personal-data-section';
import {
  DeliveryAddressFormFields,
  DeliveryAddressSection
} from './form-steps/delivery-address-section';
import { DataProtectionFormFields, SubmitSection } from './form-steps/submit-section';
import { HouseOwnerFormFields, HouseOwnerSection } from './form-steps/house-owner-section';
import { OfferFormModal } from './offer-form-modal';
import { ContentDivider } from '@components/content-divider/content-divider';

const partnerCompanyNames: Record<Partners, string> = {
  LichtBlick: 'LichtBlick SE',
  zolar: 'ZOLAR GmbH',
  Otovo: 'Otovo GmbH'
};

type OfferFormSecondProps = {
  formHeadlines: PvWizardSectionOffer['formHeadlines'];
  formModals: PvWizardSectionOffer['formModals'];
  modalContainerRef: React.RefObject<HTMLDivElement>;
  selectedPartnersContent: PvWizardSectionOffer['selectedPartnersContent'];
};

export type PartnerOfferingForm = PartnerSelectionFormFields &
  PersonalDataFormFields &
  DeliveryAddressFormFields &
  HouseOwnerFormFields &
  DataProtectionFormFields;

export const OfferFormSecond: React.FC<OfferFormSecondProps> = ({
  formHeadlines,
  formModals,
  modalContainerRef,
  selectedPartnersContent
}) => {
  const { control } = useFormContext<PartnerOfferingForm>();

  const selectedPartners = useWatch<PartnerOfferingForm, 'partners'>({
    control,
    name: 'partners'
  });

  const selectedPartnerNames = selectedPartners.map(partner => partnerCompanyNames[partner]);

  return (
    <>
      <div className={styles.offerForm}>
        <div className={styles.offerFormSection}>
          <AdacHeadline
            id="personal-data-headline"
            tagName="h3"
            styleAs="h4"
            className="margin-bottom--m"
          >
            {formHeadlines.personalDataHeadline}
          </AdacHeadline>
          <PersonalDataSection />
        </div>
        <ContentDivider className={styles.onlyDesktop} />
        <div className={styles.offerFormSection}>
          <AdacHeadline id="adress-headline" tagName="h3" styleAs="h4" className="margin-bottom--m">
            {formHeadlines.deliveryAddressHeadline}
            {formModals.locationModal && (
              <OfferFormModal
                modalContent={formModals.locationModal}
                modalRef={modalContainerRef}
              />
            )}
          </AdacHeadline>
          <DeliveryAddressSection />

          <AdacText type="medium" className="margin-top--m">
            Das Angebot richtet sich ausschließlich an Eigentümer, die selbst im Haus wohnen.
          </AdacText>
          <HouseOwnerSection />
        </div>
      </div>

      {selectedPartners.length > 0 && (
        <SelectedPartnerBox
          selectedPartners={selectedPartnerNames}
          selectedPartnersContent={selectedPartnersContent}
        />
      )}
      <SubmitSection selectedPartnerNames={selectedPartnerNames.join(' | ')} />
    </>
  );
};
